var chunkMapping = {
	"1822": [
		28562
	],
	"2111": [
		4867
	],
	"4144": [
		23186
	],
	"4197": [
		60882
	],
	"5493": [
		36799
	],
	"6419": [
		39209,
		63104,
		70238,
		85810,
		94217
	]
};
var idToExternalAndNameMapping = {
	"4867": [
		"default",
		"./group_add",
		48382
	],
	"23186": [
		"default",
		"./service_report_detail",
		43176
	],
	"28562": [
		"default",
		"./group_edit",
		48382
	],
	"36799": [
		"default",
		"./archives_detail",
		49734
	],
	"39209": [
		"default",
		"./hooks",
		63772
	],
	"60882": [
		"default",
		"./group_list",
		48382
	],
	"63104": [
		"default",
		"./charts",
		63772
	],
	"70238": [
		"default",
		"./amap",
		63772
	],
	"85810": [
		"default",
		"./utils",
		63772
	],
	"94217": [
		"default",
		"./ui",
		63772
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}